import React from 'react';

export const PhoneFrame = ({ children, className = '', size = 'md' }) => {
  const sizeClass = size === 'sm' ? 'phone-frame-sm' : size === 'lg' ? 'phone-frame-lg' : '';
  return (
    <div className={`phone-frame ${sizeClass} ${className}`.trim()}>
      <div className="phone-notch" />
      <div className="phone-screen">{children}</div>
    </div>
  );
};

export default PhoneFrame;
